import React from 'react'
import { Popconfirm } from 'antd'

interface Ret00cActionItem {
  key: string
  label: string
  icon?: React.ReactNode
  onClick?: () => void
  loading?: boolean
  disabled?: boolean
  danger?: boolean
  confirm?: {
    title: string
    description?: string
    okText?: string
    cancelText?: string
  }
}

interface Ret00cActionBarProps {
  items: Ret00cActionItem[]
  className?: string
}

export const RET00C_ACTION_BAR_WRAPPER_CLASS_NAME =
  'mb-4 h-12 border border-b border-gray-200 rounded-none bg-gray-50 px-3 py-1'

export const RET00C_ACTION_BAR_WRAPPER_STYLE: React.CSSProperties = {
  marginLeft: -24,
  marginRight: -24,
  width: 'calc(100% + 48px)',
  maxWidth: 'none',
  boxSizing: 'border-box',
}

export const RET00C_ACTION_BAR_LAYOUT_CLASS_NAME = 'flex items-center justify-between gap-4'

export const RET00C_ACTION_BAR_GROUP_CLASS_NAME = 'flex items-center flex-shrink-0 gap-4'

function Ret00cActionBar({ items, className }: Ret00cActionBarProps): JSX.Element {
  return (
    <div className={`flex items-center gap-1 ${className || ''}`} style={{ color: '#595959', fontSize: 13 }}>
      {items.map((item) => {
        const disabled = item.disabled || item.loading
        const actionNode = (
          <span
            key={item.key}
            role={disabled ? undefined : 'button'}
            tabIndex={disabled ? -1 : 0}
            onClick={disabled || item.confirm ? undefined : item.onClick}
            className={`flex items-center justify-center px-1.5 h-6 rounded cursor-pointer select-none ${
              disabled
                ? 'opacity-40 cursor-not-allowed'
                : item.danger
                  ? 'text-red-500 hover:bg-red-50'
                  : 'hover:bg-gray-100'
            }`}
          >
            {item.icon ? <span className="mr-1 inline-flex items-center">{item.icon}</span> : null}
            <span>{item.label}</span>
          </span>
        )

        if (item.confirm && item.onClick && !disabled) {
          return (
            <Popconfirm
              key={item.key}
              title={item.confirm.title}
              description={item.confirm.description}
              onConfirm={item.onClick}
              okText={item.confirm.okText}
              cancelText={item.confirm.cancelText}
            >
              {actionNode}
            </Popconfirm>
          )
        }

        return actionNode
      })}
    </div>
  )
}

export default Ret00cActionBar
